module.exports = "/1st/2026/packs/jobmatch_banner_sp-206e8d6092dd0c539097047e4b87e506.png";